<template>
  <div
    class="dij-diagrambuilder-inspections"
    ref="measurementListContainer"
    @scroll="handleScroll"
  >
    <template v-if="inspections[selectedInspectionIndex]">
      <inspection-keypad
        ref="keypad"
        :key="inspections[selectedInspectionIndex]._id"
        v-model="inspections[selectedInspectionIndex]"
        :readOnly="readOnly"
        @next="nextMeasurement"
        @done="saveInspectionByInspectionNumber"
        @deleteInspection="deleteInspection"
        @forceSaveInspection="forceSaveInspection"
      />
    </template>
    <template v-else>
      <div v-for="(inspection, index) in inspections" :key="inspection._id">
        <template
          v-if="
            inspection.type !== 'text' &&
            inspection.type !== 'link' &&
            inspection.type !== 'arrow' &&
            inspection.type !== 'line'
          "
        >
          <div
            class="dij-diagrambuilder-inspection"
            @click="
              () => {
                if (!inspection.inTable) selectInspection(inspection);
              }
            "
          >
            <div
              class="dij-diagrambuilder-inspection-number"
              @click="onInspectionNumberClick(inspection)"
            >
              <p>{{ inspection.number }}</p>
            </div>
            <div class="dij-diagrambuilder-inspection-data">
              <p class="dij-diagrambuilder-inspection-type">
                <b-icon icon="table" v-if="inspection.inTable" />
                {{ $t(inspection.type) }}
                <template v-if="shouldShowVisualInspectionFine(inspection)">
                  <span style="color: green"
                    >- {{ $t('diagram_builder.fine') }}</span
                  >
                </template>
              </p>

              <template v-if="tool === 'inspector'">
                <template v-if="inspection.inTable"></template>

                <template v-else-if="inspection.type === 'visual'">
                  <div>
                    {{ $t('rubbed') }}:
                    {{
                      inspection.measurements.length !== 0 &&
                      inspection.measurements[0].value &&
                      inspection.measurements[0].value !== 'notCompleted'
                        ? $t(inspection.measurements[0].value)
                        : '--'
                    }}
                  </div>
                  <div>
                    {{ $t('damaged') }}:
                    {{
                      inspection.measurements.length !== 0 &&
                      inspection.measurements[1].value &&
                      inspection.measurements[1].value !== 'notCompleted'
                        ? $t(inspection.measurements[1].value)
                        : '--'
                    }}
                  </div>
                  <div>
                    {{ $t('pitted') }}:
                    {{
                      inspection.measurements.length !== 0 &&
                      inspection.measurements[2].value &&
                      inspection.measurements[2].value !== 'notCompleted'
                        ? $t(inspection.measurements[2].value)
                        : '--'
                    }}
                  </div>
                  <div>
                    {{ $t('eroded') }}:
                    {{
                      inspection.measurements.length !== 0 &&
                      inspection.measurements[3].value &&
                      inspection.measurements[3].value !== 'notCompleted'
                        ? $t(inspection.measurements[3].value)
                        : '--'
                    }}
                  </div>
                </template>
                <template v-else>
                  <template
                    v-if="
                      inspection.type !== 'visual' &&
                      inspection.type === 'runout' &&
                      !inspection.multipleMeasurements
                    "
                  >
                    <div class="runout-one-measurement">
                      <div
                        :style="
                          isMeasurementOk(inspection, 0)
                            ? 'color:green'
                            : inspection.measurements &&
                              inspection.measurements[0] &&
                              inspection.measurements[0].value === ''
                            ? 'color: black'
                            : 'color:red'
                        "
                      >
                        {{ $t('tir') }}:
                        {{
                          inspection.measurements.length !== 0 &&
                          inspection.measurements[0] &&
                          !isNaN(inspection.measurements[0].value)
                            ? displayUnit === inspection.measurements[0].unit
                              ? inspection.measurements[0].value
                              : inspection.measurements[0].convertedInputValue
                            : '--'
                        }}
                      </div>
                      <div
                        :style="
                          isMeasurementOk(inspection, 0)
                            ? 'color:green'
                            : inspection.measurements &&
                              inspection.measurements[0] &&
                              inspection.measurements[0].value === ''
                            ? 'color: black'
                            : 'color:red'
                        "
                      >
                        {{ $t('position') }} :
                        {{
                          inspection.measurements.length !== 0 &&
                          inspection.measurements[1] &&
                          inspection.measurements[1].value !== ''
                            ? inspection.measurements[1].value
                            : '--'
                        }}
                        {{ $t('degrees') }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <template
                      v-if="
                        inspection.type === 'generic' &&
                        inspection.measurementName
                      "
                    >
                      <span
                        class="generic-label"
                        :title="inspection.measurementName"
                      >
                        {{ inspection.measurementName + ':' }}
                      </span>
                    </template>
                    <div
                      v-for="number in inspection.measurementCount"
                      :key="number"
                    >
                      <template v-if="inspection.type !== 'freefinding'">
                        <template v-if="inspection.type === 'generic'">
                          <span
                            class="generic-label"
                            :title="inspection.measurements[number - 1].value"
                            :style="
                              inspection.genericTolerance
                                ? isMeasurementOk(inspection, number - 1)
                                  ? 'color:green'
                                  : isInspectionMeasurementValid(
                                      inspection,
                                      number - 1
                                    )
                                  ? 'color:black'
                                  : 'color:red'
                                : 'color:black'
                            "
                          >
                            <template v-if="inspection.measurementCount > 1">
                              {{ $t('position') }} {{ number }}:
                            </template>
                            {{
                              inspection.measurements[number - 1].value !== ''
                                ? displayUnit ===
                                  inspection.measurements[number - 1].unit
                                  ? inspection.measurements[number - 1].value
                                  : inspection.measurements[number - 1]
                                      .convertedInputValue
                                : '--'
                            }}
                          </span>
                        </template>

                        <template v-else>
                          <div
                            :style="
                              isMeasurementOk(inspection, number - 1)
                                ? 'color:green'
                                : isInspectionMeasurementValid(
                                    inspection,
                                    number - 1
                                  )
                                ? 'color: black'
                                : 'color:red'
                            "
                          >
                            {{ $t('position') }} {{ number }} :
                            {{
                              inspection.measurements &&
                              inspection.measurements[number - 1] &&
                              inspection.measurements[number - 1].value
                                ? displayUnit ===
                                  inspection.measurements[number - 1].unit
                                  ? inspection.measurements[number - 1].value
                                  : inspection.measurements[number - 1]
                                      .convertedInputValue
                                : '--'
                            }}
                          </div>
                        </template>
                      </template>
                    </div>
                  </template>
                </template>
              </template>
              <template v-else>
                <template v-if="showExpectedValue(inspection)">
                  <template v-if="inspection.type === 'generic'">
                    <b-field
                      :label="$t('generic_name')"
                      class="dij-diagrambuilder-inspection-tolerance"
                    >
                      <b-input
                        type="text"
                        :disabled="isReadOnly"
                        v-model="inspection.measurementName"
                        @blur="onBlur(inspection)"
                    /></b-field>
                  </template>

                  <b-field
                    :class="{ hidden: !inspection.hasDescription }"
                    :label="$t('marker_description')"
                    class="dij-diagrambuilder-inspection-tolerance"
                  >
                    <b-input
                      type="text"
                      v-model="inspection.description"
                      @blur="onBlur(inspection)"
                      :disabled="isReadOnly"
                  /></b-field>
                  <b-field :label="$t('expected_value')">
                    <b-input
                      type="number"
                      step="any"
                      :disabled="isReadOnly"
                      v-model="inspection.expectedValue"
                      @input="updateToleranceDecimalPlaces(inspection)"
                      @blur="onBlur(inspection)"
                  /></b-field>
                  <div class="dij-diagrambuilder-inspection-tolerances">
                    <b-field
                      :label="
                        inspection.toleranceType == 'normal' ||
                        inspection.toleranceType == 'positive'
                          ? $t('positive_tolerance')
                          : $t('negative_tolerance')
                      "
                    >
                      <b-input
                        type="number"
                        step="any"
                        :disabled="isReadOnly"
                        v-model="inspection.positiveTolerance"
                        @blur="onBlur(inspection)"
                      />
                    </b-field>
                    <b-field
                      :label="
                        inspection.toleranceType == 'normal' ||
                        inspection.toleranceType == 'negative'
                          ? $t('negative_tolerance')
                          : $t('positive_tolerance')
                      "
                    >
                      <b-input
                        type="number"
                        step="any"
                        :disabled="isReadOnly"
                        v-model="inspection.negativeTolerance"
                        @blur="onBlur(inspection)"
                      />
                    </b-field>
                  </div>
                </template>
                <template v-else-if="showTolerance(inspection)">
                  <b-field
                    :class="{ hidden: !inspection.hasDescription }"
                    :label="$t('marker_description')"
                    class="dij-diagrambuilder-inspection-tolerance"
                  >
                    <b-input
                      type="text"
                      v-model="inspection.description"
                      @blur="onBlur(inspection)"
                      :disabled="isReadOnly"
                  /></b-field>
                  <b-field
                    :label="$t('tolerance')"
                    class="dij-diagrambuilder-inspection-tolerance"
                  >
                    <b-input
                      type="number"
                      step="any"
                      :disabled="isReadOnly"
                      v-model="inspection.tolerance"
                      @blur="onBlur(inspection)"
                  /></b-field>
                </template>
                <template v-else>
                  <template v-if="inspection.type === 'generic'">
                    <b-field
                      :label="$t('generic_name')"
                      class="dij-diagrambuilder-inspection-tolerance"
                    >
                      <b-input
                        type="text"
                        :disabled="isReadOnly"
                        v-model="inspection.measurementName"
                        @blur="onBlur(inspection)"
                    /></b-field>
                  </template>
                  <b-field
                    :class="{ hidden: !inspection.hasDescription }"
                    :label="$t('marker_description')"
                    class="dij-diagrambuilder-inspection-tolerance"
                  >
                    <b-input
                      type="text"
                      v-model="inspection.description"
                      @blur="onBlur(inspection)"
                      :disabled="isReadOnly"
                  /></b-field>
                  <!-- Visual or Freefinding -->
                </template>
              </template>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import InspectionKeypad from './InspectionKeypad';
import { GET_CURRENT_TASK } from '../../store/tasks/getters/getterTypes';
import { GET_CURRENT_JOB } from '../../store/jobs/getters/getterTypes';
import BubbleDTO from '../../shared/dtos/BubbleDTO';
import KeyHandlerMixin from '../../mixins/KeyHandlerMixin';
import { GET_CURRENT_DISPLAY_UNIT } from '../../store/diagram/getters/getterTypes';

export default {
  components: { InspectionKeypad },
  name: 'inspection-list',
  props: {
    value: {
      type: Array,
      required: true,
    },
    tool: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedInspectionIndex: null,
      scrollValue: 0,
    };
  },
  mixins: [KeyHandlerMixin],
  computed: {
    inspections: {
      get() {
        const sortedValue = this.value
          .slice()
          .sort((a, b) => a.number - b.number);
        return sortedValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    job() {
      return this.$store.getters[GET_CURRENT_JOB];
    },
    task() {
      return this.$store.state.task && this.$store.state.task._id
        ? this.$store.state.task
        : this.$store.getters[GET_CURRENT_TASK];
    },
    isTaskCompleted() {
      return this.task.workStatusCode
        ? this.task.workStatusCode.toString() === '2' || this.job.jobCompleted
        : false;
    },
    displayUnit() {
      return this.$store.getters[GET_CURRENT_DISPLAY_UNIT];
    },
    isReadOnly() {
      return this.readOnly || this.isTaskCompleted;
    },
  },
  methods: {
    countDecimalPlaces(value) {
      if (!value) {
        return 0;
      }

      const numString = typeof value === 'number' ? value.toString() : value;

      const parts = numString.split('.');

      if (parts.length === 2) {
        return parts[1].length;
      }

      return 0;
    },
    adjustToleranceValue(inspection) {
      const numberOfDecimals = this.countDecimalPlaces(
        inspection.expectedValue
      );

      const adjustTolerance = (tolerance) => {
        return tolerance !== undefined
          ? parseFloat(tolerance || 0).toFixed(numberOfDecimals)
          : tolerance;
      };

      inspection.positiveTolerance = adjustTolerance(
        inspection.positiveTolerance
      );
      inspection.negativeTolerance = adjustTolerance(
        inspection.negativeTolerance
      );
    },

    handleScroll() {
      if (this.$refs.measurementListContainer.scrollTop !== 0) {
        this.scrollValue = this.$refs.measurementListContainer.scrollTop;
      }
    },
    isInspectionMeasurementValid(inspection, measurementIndex) {
      if (measurementIndex > inspection.measurements.length) {
        console.error(
          `Inspection ${inspection._id} has measurement count${inspection.measurementCount} but measurements are ${inspection.measurements.length}`
        );
        return false;
      }

      return (
        inspection.measurements &&
        inspection.measurements[measurementIndex] &&
        inspection.measurements[measurementIndex].value === ''
      );
    },
    shouldShowVisualInspectionFine(inspection) {
      return (
        this.tool === 'inspector' &&
        inspection.type === 'visual' &&
        !inspection.inTable &&
        inspection.measurements
          .slice(0, 4)
          .every((measurement) => measurement.value === '')
      );
    },
    onInspectionNumberClick(inspection) {
      if (this.tool !== 'inspector') {
        this.$parent.focusOnMarker(inspection);
      }
    },
    isMeasurementOk(inspection, measurementNumber) {
      return this.$parent.isMeasurementOk(inspection, measurementNumber);
    },
    onBlur(inspection) {
      this.adjustToleranceValue(inspection);

      this.saveInspection(inspection);
    },
    showExpectedValue(inspection) {
      return (
        inspection.type === 'diameter' ||
        inspection.type === 'length' ||
        (inspection.type === 'generic' && inspection.genericTolerance)
      );
    },
    showTolerance(inspection) {
      return inspection.type === 'runout';
    },
    updateToleranceDecimalPlaces(inspection) {
      if (inspection.expectedValue) {
        const expectedValueSplitted = inspection.expectedValue
          .toString()
          .split('.');
        const numberOfDecimalPlaces =
          expectedValueSplitted.length === 1
            ? 0
            : expectedValueSplitted[1].length;

        inspection.positiveTolerance = parseFloat(
          inspection.positiveTolerance,
          10
        ).toFixed(numberOfDecimalPlaces);
        inspection.negativeTolerance = parseFloat(
          inspection.negativeTolerance,
          10
        ).toFixed(numberOfDecimalPlaces);
      }
    },
    isSelectionAllowed() {
      return this.tool === 'inspector';
    },
    selectInspection(selectedInspection) {
      if (!this.isSelectionAllowed()) {
        return;
      }
      const index = this.inspections.findIndex(
        (inspection) => inspection._id === selectedInspection._id
      );
      if (this.selectedInspectionIndex !== null) {
        this.$parent.blurFromMarker(
          this.inspections[this.selectedInspectionIndex]
        );
      }

      // Check if the selected inspection exists in the list
      if (index < 0) return;
      this.selectedInspectionIndex = index;
      this.$parent.showMultipleMeasurementSelector(
        this.inspections[this.selectedInspectionIndex]
      );
      this.$parent.focusOnMarker(
        this.inspections[this.selectedInspectionIndex]
      );

      if (this.$refs.keypad) {
        this.$refs.keypad.refreshUI();
      }
    },
    nextMeasurement() {
      this.$parent.showMultipleMeasurementSelector(
        this.inspections[this.selectedInspectionIndex]
      );
      this.$parent.remakeMarker(this.inspections[this.selectedInspectionIndex]);

      this.$parent.selectTableInspection(
        this.inspections[this.selectedInspectionIndex]
      );
      if (this.$refs.keypad.isLastMeasurement()) {
        this.setKeyHandlerCallback('next', this.nextBubble);
      }
    },
    nextBubble() {
      this.selectedInspectionIndex++;
      if (this.selectedInspectionIndex <= this.inspections.length - 1) {
        this.selectInspection(this.inspections[this.selectedInspectionIndex]);
      } else {
        this.selectedInspectionIndex = 0;
      }
    },
    saveInspectionByInspectionNumber() {
      // Check if the user chnaged any value or just open and close the bubble

      this.saveInspection(this.inspections[this.selectedInspectionIndex]);

      this.$parent.blurFromMarker(
        this.inspections[this.selectedInspectionIndex]
      );

      if (this.inspections[this.selectedInspectionIndex].inTable) {
        this.inspections.forEach((inspection) => {
          if (inspection.inTable) {
            inspection.measurements = [];
          }
          this.$parent.remakeMarker(inspection);
        });
      }
      this.$parent.remakeMarker(this.inspections[this.selectedInspectionIndex]);
      if (
        this.inspections[this.selectedInspectionIndex].inTable &&
        this.inspections[this.selectedInspectionIndex].type === 'generic'
      ) {
        this.$parent.remakeMarker(
          this.inspections[this.selectedInspectionIndex],
          false,
          true
        );
      }

      this.selectedInspectionIndex = null;

      setTimeout(() => {
        this.$refs.measurementListContainer.scrollTop = this.scrollValue;
      }, 0);
      this.$refs.keypad.refreshUI();
    },
    forceSaveInspection() {
      this.saveInspection(this.inspections[this.selectedInspectionIndex]);
    },
    async saveInspection(inspection) {
      if (this.isTaskCompleted) {
        return;
      }
      if (this.isReadOnly) {
        return;
      }
      if (!inspection) {
        console.log('Cannot save invalid inspection');
        return;
      }
      const isInspector = this.tool === 'inspector';
      await this.$parent.handleBubbleUpdate({
        ...new BubbleDTO(inspection),
        isInspector,
      });
    },
    deleteInspection() {
      this.$parent.blurFromMarker(
        this.inspections[this.selectedInspectionIndex]
      );

      this.$parent.deleteInspection();

      this.selectedInspectionIndex = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.dij-diagrambuilder-inspections {
  position: absolute;
  right: 0;
  width: 225px;
  height: calc(100vh - 100px);
  overflow-y: auto;
}
.dij-diagrambuilder-inspection {
  display: flex;
  justify-content: center;
  border: 1px solid lightgrey;
  background-color: white;
  padding: 5px;
}
.dij-diagrambuilder-inspection-number {
  padding-top: 20px;
  flex: 0 0 30%;
  p {
    font-size: 200%;
    font-weight: bold;
    text-align: center;
  }
}

.dij-diagrambuilder-inspection-number:hover {
  cursor: pointer;
}
.dij-diagrambuilder-inspection-data {
  flex: 0 0 70%;
}
.dij-diagrambuilder-inspection-type {
  font-weight: bold;
  font-size: 110%;
}
.dij-diagrambuilder-inspection-tolerances {
  display: flex;
  gap: 3px;
}
.dij-diagrambuilder-inspection-tolerance {
  margin-bottom: 0.75rem;
}
// lower the text size for label and fields
.field ::v-deep label,
.control ::v-deep input {
  font-size: 75%;
}

.runout-one-measurement {
  display: flex;
  flex-direction: column;
}

.generic-label {
  display: block;
  max-width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
